import { Button, Replace, ReplaceGradient, Spacer } from '@sparemin/blockhead';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ProBadge } from 'components/icons';
import LinkButton from 'components/LinkButton';
import useContextualUpgrade from 'hooks/useContextualUpgrade';
import useRestoreVideo from 'hooks/useRestoreVideo';
import { hideModal } from 'redux/modules/modal';
import { hasRestoreEmbedVideoAccessSelector } from 'redux/modules/pricing';
import { Dispatch } from 'redux/types';
import { useEmbedVideoId } from './ProjectPreviewModalContext';

export interface ProjectPreviewModalArchivedButtonProps {}

const ProjectPreviewModalArchivedButton: React.FC<ProjectPreviewModalArchivedButtonProps> = () => {
  const hasRestoreEmbedVideoAccess = useSelector(
    hasRestoreEmbedVideoAccessSelector,
  );
  const embedVideoId = useEmbedVideoId();
  const { onUpgrade } = useContextualUpgrade();
  const { isRestoring, onRestoreVideo } = useRestoreVideo({
    embedVideoId,
    onRestoreSettled: () => dispatch(hideModal()),
  });

  const dispatch = useDispatch<Dispatch>();

  if (!hasRestoreEmbedVideoAccess) {
    return (
      <LinkButton theme="rainbow" onClick={onUpgrade}>
        <Spacer space="8px" align="center" justify="center">
          <ReplaceGradient />
          <span>Restore</span> <ProBadge />
        </Spacer>
      </LinkButton>
    );
  }

  return (
    <Button
      variant="special"
      isDisabled={isRestoring}
      startIcon={<Replace />}
      onPress={onRestoreVideo}
    >
      Restore
    </Button>
  );
};

export default ProjectPreviewModalArchivedButton;
